import { render, staticRenderFns } from "./Table.component.vue?vue&type=template&id=365b131f&"
import script from "./Table.component.vue?vue&type=script&lang=js&"
export * from "./Table.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports